import { render, staticRenderFns } from "./NewsletterCancel.vue?vue&type=template&id=1ad1d1d0"
import script from "./NewsletterCancel.vue?vue&type=script&lang=js"
export * from "./NewsletterCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports